import { ChartComponent } from "ng-apexcharts";
import { CommonModule } from "@angular/common";
import { CountUpModule } from 'ngx-countup';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { defineElement } from "@lordicon/element";
import { FormsModalModule } from "src/app/forms-modal/forms-modal.module";
import { FormsModule } from "@angular/forms";
import lottie from 'lottie-web';
import { MapSimLocationsModule } from "../widget-no-formsmodalmodule/map-sim-locations/map-sim-locations.module";
import { NgbDropdownModule, NgbTooltipModule } from "@ng-bootstrap/ng-bootstrap";
import { ProvisioningModuleContentShared } from "src/app/pages-content-shared/provisioning-content-shared/provisioning.module-content-shared";
import { RouterModule } from "@angular/router";
import { SharedModule } from "../shared.module";
import { StatTileModule } from "../stat-tile/stat-tile.module";
import { WidgetModule } from "../widget/widget.module";
import { WidgetRowAlertsComponent } from "./widget-row-alerts/widget-row-alerts.component";
import { WidgetRowLicencesComponent } from "./widget-row-licences/widget-row-licences.component";
import { WidgetRowMdmDeviceCompliance01Component } from "./widget-row-mdm-device-compliance-01/widget-row-mdm-device-compliance-01.component";
import { WidgetRowMdmDeviceCompliance02Component } from "./widget-row-mdm-device-compliance-02/widget-row-mdm-device-compliance-02.component";
import { WidgetRowMdmDevices01Component } from "./widget-row-mdm-devices-01/widget-row-mdm-devices-01.component";
import { WidgetRowMdmDevices02Component } from "./widget-row-mdm-devices-02/widget-row-mdm-devices-02.component";
import { WidgetRowMdmDevices03Component } from "./widget-row-mdm-devices-03/widget-row-mdm-devices-03.component";
import { WidgetRowMdmDevices04Component } from "./widget-row-mdm-devices-04/widget-row-mdm-devices-04.component";
import { WidgetRowPlatformComponent } from "./widget-row-platform/widget-row-platform.component";
import { WidgetRowSimProfitComponent } from 'src/app/shared/widget-rows/widget-row-sim-profit/widget-row-sim-profit.component';
import { WidgetRowSimsComponent } from "./widget-row-sims/widget-row-sims.component";
import { WidgetRowTotalCostsComponent } from "./widget-row-total-costs/widget-row-total-costs.component";
import { WidgetRowTotalCostsProfitComponent } from "./widget-row-total-costs-profit/widget-row-total-costs-profit.component";
import { WidgetRowUsageComponent } from "./widget-row-usage/widget-row-usage.component";
import { WidgetRowUsageDashboardDistributionComponent } from "./widget-row-usage-dashboard/widget-row-usage-dashboard-distribution/widget-row-usage-dashboard-distribution.component";
import { WidgetRowUsageDashboardStatsComponent } from "./widget-row-usage-dashboard/widget-row-usage-dashboard-stats/widget-row-usage-dashboard-stats.component";
import { WidgetRowUsageDashboardSummaryComponent } from "./widget-row-usage-dashboard/widget-row-usage-dashboard-summary/widget-row-usage-dashboard-summary.component";
import { WidgetRowUsageDashboardTopSimsComponent } from "./widget-row-usage-dashboard/widget-row-usage-dashboard-top-sims/widget-row-usage-dashboard-top-sims.component";

@NgModule({
  declarations: [
    WidgetRowAlertsComponent,
    WidgetRowLicencesComponent,
    WidgetRowMdmDeviceCompliance01Component,
    WidgetRowMdmDeviceCompliance02Component,
    WidgetRowMdmDevices01Component,
    WidgetRowMdmDevices02Component,
    WidgetRowMdmDevices03Component,
    WidgetRowMdmDevices04Component,
    WidgetRowPlatformComponent,
    WidgetRowSimProfitComponent,
    WidgetRowSimsComponent,
    WidgetRowTotalCostsComponent,
    WidgetRowTotalCostsProfitComponent,
    WidgetRowUsageComponent,
    WidgetRowUsageDashboardDistributionComponent,
    WidgetRowUsageDashboardStatsComponent,
    WidgetRowUsageDashboardSummaryComponent,
    WidgetRowUsageDashboardTopSimsComponent
  ],
  imports: [
    ChartComponent,
    CommonModule,
    CountUpModule,
    FormsModalModule,
    FormsModule,
    MapSimLocationsModule,
    NgbDropdownModule,
    NgbTooltipModule,
    ProvisioningModuleContentShared,
    RouterModule,
    SharedModule,
    StatTileModule,
    WidgetModule
  ],
  exports: [
    WidgetRowAlertsComponent,
    WidgetRowLicencesComponent,
    WidgetRowMdmDeviceCompliance01Component,
    WidgetRowMdmDeviceCompliance02Component,
    WidgetRowMdmDevices01Component,
    WidgetRowMdmDevices02Component,
    WidgetRowMdmDevices03Component,
    WidgetRowMdmDevices04Component,
    WidgetRowPlatformComponent,
    WidgetRowSimProfitComponent,
    WidgetRowSimsComponent,
    WidgetRowTotalCostsComponent,
    WidgetRowTotalCostsProfitComponent,
    WidgetRowUsageComponent,
    WidgetRowUsageDashboardDistributionComponent,
    WidgetRowUsageDashboardStatsComponent,
    WidgetRowUsageDashboardSummaryComponent,
    WidgetRowUsageDashboardTopSimsComponent
  ],
    schemas: [
      CUSTOM_ELEMENTS_SCHEMA
    ]
})

export class WidgetRowsModule {
  constructor() {
    defineElement(lottie.loadAnimation);
  }
}
